/* @generated from adl module ferovinum.datacontracts.expensestatusevent */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface ExpenseStatusEventRawRecord {
  id: common_strings.StringNE;
  expenseId: common_strings.StringNE;
  status: common_strings.StringNE;
  transitionedAt: common.Instant;
  notes: string;
  userId: (common_strings.StringNE|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeExpenseStatusEventRawRecord(
  input: {
    id: common_strings.StringNE,
    expenseId: common_strings.StringNE,
    status: common_strings.StringNE,
    transitionedAt: common.Instant,
    notes: string,
    userId: (common_strings.StringNE|null),
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): ExpenseStatusEventRawRecord {
  return {
    id: input.id,
    expenseId: input.expenseId,
    status: input.status,
    transitionedAt: input.transitionedAt,
    notes: input.notes,
    userId: input.userId,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const ExpenseStatusEventRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.expensestatusevent","decl":{"annotations":[{"value":{"datasetName":"raw_expense_status_events"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseId","default":{"kind":"nothing"},"name":"expenseId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"transitionedAt","default":{"kind":"nothing"},"name":"transitionedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"notes","default":{"kind":"nothing"},"name":"notes","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"userId","default":{"kind":"nothing"},"name":"userId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"ExpenseStatusEventRawRecord","version":{"kind":"nothing"}}};

export const snExpenseStatusEventRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.expensestatusevent", name:"ExpenseStatusEventRawRecord"};

export function texprExpenseStatusEventRawRecord(): ADL.ATypeExpr<ExpenseStatusEventRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snExpenseStatusEventRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.expensestatusevent.ExpenseStatusEventRawRecord" : ExpenseStatusEventRawRecord_AST
};
